import * as constants from '../constants';

export const requestDashboard = (
    id,
    startDate = null,
    endDate = null,
    instanceType = constants.INSTANCE_FILTERS.COMPLETED,
) => ({
    type: constants.DASHBOARD_REQUESTED,
    payload: {id, startDate, endDate, instanceType},
});

export const dashboardSuccess = (
    item,
    startDate = null,
    endDate = null,
    instanceType = constants.INSTANCE_FILTERS.COMPLETED,
) => ({
    type: constants.DASHBOARD_SUCCESS,
    payload: {item, startDate, endDate, instanceType},
});

export const dashboardFailure = (error) => ({
    type: constants.DASHBOARD_FAILURE,
    payload: {error},
});

export const requestDashboardExport = (id, params) => ({
    type: constants.DASHBOARD_EXPORT_REQUESTED,
    payload: {id, params},
});

export const dashboardExportSuccess = (id, data) => ({
    type: constants.DASHBOARD_EXPORT_SUCCESS,
    payload: {id, data},
});

export const dashboardExportFailure = (error, id) => ({
    type: constants.DASHBOARD_EXPORT_FAILURE,
    payload: {error, id},
});
